<template>
  <div class="account-settings">
    <Header />
    <div class="settings-main">
      <SettingsNavigation></SettingsNavigation>
      <div class="profile">
        <div class="profile-main">
          <div class="input-boxs">
            <div>Account</div>
            <input type="text" v-model="userName" disabled class="disabled" />
          </div>
          <div class="explain">
            The system automatically assigned a username to your account when
            you registered. After choosing a username here, you will no longer
            be able to change it
          </div>
          <div class="input-boxs">
            <div>Full Name</div>
            <input
              type="text"
              v-model="form.name"
              :class="[{ disabled: nameDisabled }]"
              :disabled="nameDisabled"
            />
          </div>
          <div class="input-boxs">
            <div>Gender</div>
            <el-select
              v-model="form.gender"
              placeholder="Please select"
              size="mini"
              :disabled="genderDisabled"
            >
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </div>
          <div class="input-boxs">
            <div>D O B</div>
            <el-date-picker
              size="mini"
              v-model="form.birthday"
              type="date"
              placeholder="Select date"
              :disabled="birthdayDisabled"
            >
            </el-date-picker>
          </div>
          <div class="input-boxs">
            <div>Country (region)</div>
            <el-select
              v-model="form.country"
              placeholder="Please select"
              size="mini"
            >
              <el-option
                v-for="item in areaList"
                :key="item.id"
                :label="item.nameCn"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </div>
          <div :class="['update', { 'update-check': checked }]" @click="submit">
            <div>update</div>
          </div>
        </div>
        <Account></Account>
      </div>
      <AvatarUrl></AvatarUrl>
    </div>
    <Footer />
  </div>
</template>
<script>
import Header from "./mycom/header.vue";
import Footer from "./mycom/footer.vue";
import SettingsNavigation from "./mycom/settingsNavigation.vue";
import AvatarUrl from "./mycom/avatarUrl.vue";
import Account from "./mycom/account.vue";
import { users, Countries, accountsProfile } from "@/api/api.js";
import { Notify } from "vant";
export default {
  components: { Header, Footer, SettingsNavigation, AvatarUrl, Account },
  data() {
    return {
      pageShow: false,
      checked: false,
      userName: "",
      nameDisabled: false,
      genderDisabled: false,
      birthdayDisabled: false,
      form: {
        name: "",
        value: null,
      },
      options: [
        {
          value: 1,
          label: "Male",
        },
        {
          value: 2,
          label: "Female",
        },
      ],
      value: null,
      value1: "",
      areaList: [],
    };
  },
  methods: {
    submit() {
      if (this.checked) return;
      this.checked = true;
      const loginInfo = JSON.parse(localStorage.getItem("LOGIN_INFO"));
      const form = this.form;
      const params = form;
      params.id = loginInfo.id;
      accountsProfile(params).then((res) => {
        if (res.code === 200) {
          Notify({ type: "success", message: this.$t("updateInfoSuc") });
          this.getUsers();
        } else {
          Notify({ type: "danger", message: res.errors[0] });
        }
      });
    },

    getUsers() {
      const loginInfo = JSON.parse(localStorage.getItem("LOGIN_INFO"));
      const params = {
        id: loginInfo.id,
      };
      users(params).then((res) => {
        //console.log(res);
        if (res.code === 200) {
          this.pageShow = true;
          this.form = res.data;
          if (res.data.name) {
            this.nameDisabled = true;
          }
          if (res.data.gender) {
            this.genderDisabled = true;
          }
          if (res.data.birthday) {
            this.birthdayDisabled = true;
          }
        } else {
          Notify({ type: "danger", message: res.errors[0] });
        }
      });
    },

    getCountry() {
      Countries({}).then((res) => {
        if (res.code === 200) {
          this.areaList = res.data;
          console.log(" this.areaList", this.areaList);
        } else {
          Notify({ type: "danger", message: res.errors[0] });
        }
      });
    },
  },
  created() {
    this.userName = JSON.parse(localStorage.getItem("accountInfo")).userName;
    this.getUsers();
    this.getCountry();
  },
};
</script>
<style scoped>
.account-settings {
  padding-top: 40px;
  min-height: calc(100vh - 40px);
  background-color: #fff;
}
header {
  position: fixed;
  top: 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  background: #ffffff;
  z-index: 999;
  box-shadow: 0px 3px 6px 1px #c6c5c6;
}
.settings-main {
  width: calc(100% - 175px);
  padding: 20px 87.5px;
  display: flex;
}
.profile {
  width: 100%;
}
.profile-main {
  width: 337.5px;
  margin-left: 40.625px;
}
input {
  width: calc(100% - 11.25px);
  height: 28px;
  line-height: 28px;
  border-radius: 1.25px;
  border: 0.625px solid #dddddd;
  padding-left: 10px;
  font-size: 10px;
}
.input-boxs > div {
  font-size: 10px;
  margin-bottom: 7px;
  margin-top: 15px;
}
.explain {
  margin-top: 12.5px;
  font-size: 10px;
  line-height: 15px;
  margin-bottom: 12.5px;
}
.equal-rank {
  display: flex;
  justify-content: space-between;
  margin-top: 12.5px;
  margin-bottom: 10px;
}
.rank-left {
  width: calc(50% -30.625px);
}
.rank-right {
  width: calc(50% -30.625px);
}
.update {
  width: 100%;
  display: flex;
  justify-content: flex-end;
}
.update > div {
  width: 81.875px;
  height: 22.5px;
  border-radius: 1.5px;
  border: 0.625px solid #2e67ea;
  text-align: center;
  line-height: 22.5px;
  margin-top: 30px;
  color: #2e67ea;
  font-size: 10px;
  cursor: pointer;
}
.update-check > div {
  background-color: #2e67ea;
  color: #fff;
}
.disabled {
  color: #dcdbe2;
  background-color: #f5f7fa;
  cursor: no-drop;
}
</style>
<style scoped>
.input-boxs >>> .el-select {
  width: 100%;
}

.input-boxs >>> .el-input__inner {
  border-radius: 1.25px;
  border: 0.625px solid #dddddd;
  outline: none;
  font-size: 10px;
  padding-left: 10px;
}
.input-boxs >>> .el-input__prefix {
  display: none;
}
.input-boxs >>> .el-date-editor {
  width: 100%;
}
</style>


// WEBPACK FOOTER //
// src/components/profile.vue